import {useMutation, gql} from '@apollo/client'

export const MUTATE_SAVE_PROSPECT_LIST = gql`
  mutation MUTATE_SAVE_PROSPECT_LIST(
    $listName: String!
    $constituentIdList: [String!]!
    $listDescription: String
    $azureRole: String
  ) {
    saveList(
      listName: $listName
      constituentIdList: $constituentIdList
      listDescription: $listDescription
      azureRole: $azureRole
    ) {
      saveList {
        listName
        constituentIdList
        listDescription
      }
    }
  }
`

export function useSaveProspectList() {
  return useMutation(MUTATE_SAVE_PROSPECT_LIST, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
